import React, { useEffect, useState, useRef } from 'react';
import Layout from '../components/layout/Layout';

function StopwatchPage() {
  const [settings, setSettings] = useState(null);
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [stoppedAt, setStoppedAt] = useState(null);
  const [result, setResult] = useState(null);
  const [token, setToken] = useState(null);
  const [authError, setAuthError] = useState(null);
  const [backendError, setBackendError] = useState(null);

  const timerRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    fetch('https://www.sunpanda.ru/Volgodonsk/api/v2/stopwatch-settings', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSettings(data.data);
          setBackendError(null);
          startStopwatch();
        } else {
          // Если ошибка от бэка
          setBackendError(data.message || 'Ошибка получения настроек');
          setSettings(null);
        }
      })
      .catch((err) => {
        console.error('Ошибка загрузки настроек:', err);
        setBackendError('Ошибка загрузки настроек');
        setSettings(null);
      });
  }, [token]);

  const handleAuth = () => {
    fetch('https://www.sunpanda.ru/Volgodonsk/api/v2/test-auth')
      .then((res) => res.json())
      .then((data) => {
        if (data.token) {
          setToken(data.token);
          setAuthError(null);
        } else {
          setAuthError('Не удалось получить токен');
        }
      })
      .catch((err) => {
        console.error('Ошибка авторизации:', err);
        setAuthError('Ошибка авторизации');
      });
  };

  const startStopwatch = () => {
    setTime(0);
    setResult(null);
    setStoppedAt(null);
    startTimeRef.current = Date.now();
    setIsRunning(true);
    timerRef.current = setInterval(() => {
      setTime((prev) => {
        const next = prev + 0.01;
        if (next >= 12) stopStopwatch(next, false);
        return next;
      });
    }, 10);
  };

  const stopStopwatch = (currentTime = time, byUser = true) => {
    clearInterval(timerRef.current);
    setIsRunning(false);

    const finishedAt = Date.now();
    const actualTime = parseFloat(currentTime.toFixed(2));
    let displayedTime = actualTime; // то, что увидит пользователь

    // если can_win true и время в диапазоне 9.5–10.0, подгоняем отображаемое время на 10.00
    if (settings?.can_win && actualTime >= 9.5 && actualTime <= 10.0) {
      displayedTime = 10.00;
    }

    // Определяем результат
    let reason = '';
    if (!byUser) {
      reason = 'Жаль… А мог бы испытать удачу (время истекло)';
    } else if (displayedTime === 10.00) {
      reason = 'Поздравляем, Ваш заказ приедет Вам за наш счёт!';
    } else if (actualTime >= 9.5 && actualTime <= 10.0) {
      reason = settings?.can_win
        ? 'Вы попали в диапазон и Вам повезло! (can_win = true)'
        : 'Вы попали в диапазон, но сегодня не повезло (can_win = false)';
    } else {
      reason = 'Вы не попали в нужное время.';
    }

    setStoppedAt(actualTime.toFixed(2));
    setResult({
      stopwatch_history_id: settings?.stopwatch_history_id,
      is_success: settings?.can_win && displayedTime === 10.00,
      final_time: displayedTime.toFixed(2),
      actual_time: actualTime.toFixed(2), // фактическое время
      started_at: startTimeRef.current,
      finished_at: finishedAt,
      reason,
    });
    setTime(displayedTime);
  };

  const handleReplay = () => {
    setTime(0);
    setResult(null);
    setStoppedAt(null);
    setIsRunning(false);
    startStopwatch();
  };

  return (
    <Layout>
      <div
        style={{
          padding: '40px',
          fontFamily: 'Inter, sans-serif',
          maxWidth: '700px',
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        {!token ? (
          <button
            onClick={handleAuth}
            style={{
              fontSize: '18px',
              padding: '10px 25px',
              borderRadius: '8px',
              background: '#28a745',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '20px',
            }}
          >
            Авторизоваться
          </button>
        ) : (
          <p style={{ color: 'green', fontWeight: 'bold' }}>Авторизация выполнена</p>
        )}

        {backendError && (
          <div style={{ margin: '20px 0', color: 'red' }}>
            <p>{backendError}</p>
            <button
              onClick={handleAuth}
              style={{
                fontSize: '16px',
                padding: '8px 20px',
                borderRadius: '8px',
                background: '#28a745',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                marginTop: '10px',
              }}
            >
              Попробовать снова
            </button>
          </div>
        )}

        {authError && <p style={{ color: 'red' }}>{authError}</p>}

        <h2 style={{ marginTop: '20px' }}>Тест секундомера</h2>

        {!backendError && !settings && token && <p>Загрузка настроек...</p>}

        {!backendError && settings && (
          <>
            <h4 className='m-4'>Информация с бэка:</h4>
            <ul>
              <li>Можно выиграть (can_win): {settings.can_win ? 'Да' : 'Нет'}</li>
              <li>Сумма заказа: {settings.cart_amount}</li>
              <li>Тип: {settings.entity.type}</li>
              <li>Название: {settings.entity.name}</li>
              <li>Процент выигрыша: {settings.entity.win_percentage}%</li>
              <li>
                Диапазон суммы заказов: {settings.stopwatch_data.min_price} – {settings.stopwatch_data.max_price}
              </li>
              <li>ID истории: {settings.stopwatch_history_id}</li>
            </ul>

            <h3 className='mt-4'>Секундомер</h3>
            <div
              style={{
                margin: '30px auto',
                background: '#1e1e2f',
                color: '#fff',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 0 25px rgba(0,0,0,0.2)',
                display: 'inline-block',
              }}
            >
              <div
                style={{
                  fontSize: '64px',
                  fontWeight: 'bold',
                  fontFamily: 'monospace',
                  marginBottom: '20px',
                  color: isRunning ? '#00ff99' : '#ffcc00',
                  transition: 'color 0.3s ease',
                }}
              >
                {time.toFixed(2)} сек
              </div>

              {isRunning ? (
                <button
                  onClick={() => stopStopwatch()}
                  style={{
                    fontSize: '22px',
                    padding: '12px 35px',
                    borderRadius: '10px',
                    background: '#ff3b30',
                    color: '#fff',
                    border: 'none',
                    cursor: 'pointer',
                    transition: '0.2s',
                  }}
                >
                  СТОП
                </button>
              ) : (
                stoppedAt &&
                result && (
                  <button
                    onClick={handleReplay}
                    style={{
                      fontSize: '20px',
                      padding: '10px 30px',
                      borderRadius: '8px',
                      background: '#007bff',
                      color: '#fff',
                      border: 'none',
                      cursor: 'pointer',
                      marginTop: '20px',
                    }}
                  >
                    Играть снова
                  </button>
                )
              )}
            </div>

            {result && (
              <div
                style={{
                  marginTop: '30px',
                  background: '#f9f9f9',
                  padding: '20px',
                  borderRadius: '10px',
                  textAlign: 'left',
                }}
              >
                <h3>Результат</h3>
                <p><strong>{result.reason}</strong></p>
                <p>Фактическое время: {result.actual_time} сек</p>
                <p>Отображаемое время: {result.final_time} сек</p>
                <pre
                  style={{
                    background: '#efefef',
                    padding: '10px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    overflowX: 'auto',
                  }}
                >
                  {JSON.stringify(result, null, 2)}
                </pre>
              </div>
            )}
          </>
        )}
      </div>
    </Layout>
  );
}

export default StopwatchPage;
